import {
	AUTH_CONFIG,
	RoleClassification
} from '@appConfig/authorization-config';

export class Roles {
	public roles: string[] = undefined;
}

export enum RoleTypes {
	ACCOUNT_ADMIN = 'admin_account',
	ARCHIVE_ADMIN = 'admin_archiving',
	ARCHIVING_USER = 'user_archiving',
	CUSTOMER_ADMIN = 'customer_admin',
	DISTRIBUTOR_ADMIN = 'admin_distributor',
	ENTITY_ADMIN = 'admin_entity',
	PARTNER_ADMIN = 'admin_partner',
	RESELLER_ADMIN = 'admin_reseller',
	SITE_ADMIN = 'admin_site',
	SUPPORT_ADMIN = 'admin_support',
	SUPPORT_ADMIN_VIEW = 'admin_support_view',
	TAXPAYER = 'taxpayer',
	TENANT_ADMIN = 'admin_tenant',
	VENDOR_ADMIN = 'admin_vendor',
}

export interface IRoleClassificationData {
	classification: RoleClassification;
	classificationOrder: number;
}

export interface IRoleData extends IRoleClassificationData {
	rolePermissionLvl: number;
}


export interface IRoleClassificationRoles extends IRoleClassificationData {
	roleTypes: RoleTypes[];
}


export type SupportRoleTypes =
	RoleTypes.SUPPORT_ADMIN |
	RoleTypes.SUPPORT_ADMIN_VIEW;

export type TenantsManagingAdminRoleTypes =
	RoleTypes.ACCOUNT_ADMIN |
	RoleTypes.PARTNER_ADMIN |
	RoleTypes.RESELLER_ADMIN |
	RoleTypes.DISTRIBUTOR_ADMIN |
	RoleTypes.SUPPORT_ADMIN |
	RoleTypes.SUPPORT_ADMIN_VIEW |
	RoleTypes.TENANT_ADMIN |
	RoleTypes.VENDOR_ADMIN;

export type ManagementRoleTypes =
	RoleTypes.ACCOUNT_ADMIN |
	RoleTypes.DISTRIBUTOR_ADMIN |
	RoleTypes.ENTITY_ADMIN |
	RoleTypes.PARTNER_ADMIN |
	RoleTypes.RESELLER_ADMIN |
	RoleTypes.SITE_ADMIN |
	RoleTypes.TENANT_ADMIN |
	RoleTypes.VENDOR_ADMIN;

export type ArchivingRoleTypes =
	RoleTypes.ARCHIVE_ADMIN |
	RoleTypes.ARCHIVING_USER;

export type CustomerRoleTypes =
	RoleTypes.CUSTOMER_ADMIN;

export const ARCHIVING_ROLES: RoleTypes[] = Object.keys( AUTH_CONFIG ).filter(
	role => AUTH_CONFIG[ role ].type === RoleClassification.ARCHIVING ) as RoleTypes[];
export const MANAGEMENT_ROLES: RoleTypes[] = Object.keys( AUTH_CONFIG ).filter(
	role => AUTH_CONFIG[ role ].type === RoleClassification.MANAGEMENT ) as RoleTypes[];
export const SUPPORT_ROLES: RoleTypes[]
	= Object.keys( AUTH_CONFIG ).filter( role => AUTH_CONFIG[ role ].type === RoleClassification.SUPPORT ) as RoleTypes[];
export const ADDITIONAL_ROLES: RoleTypes[]
	= Object.keys( AUTH_CONFIG ).filter(role => AUTH_CONFIG[ role ].type === RoleClassification.ADDITIONAL ) as RoleTypes[];

export const TENANT_MANAGING_ADMIN_ROLES: RoleTypes[] = [
	RoleTypes.ACCOUNT_ADMIN,
	RoleTypes.DISTRIBUTOR_ADMIN,
	RoleTypes.PARTNER_ADMIN,
	RoleTypes.RESELLER_ADMIN,
	RoleTypes.SUPPORT_ADMIN,
	RoleTypes.SUPPORT_ADMIN_VIEW,
	RoleTypes.TENANT_ADMIN,
	RoleTypes.VENDOR_ADMIN
];

export interface IPermissionLevel {
	[ key: string ]: number;
}

export const CLASSIFICATION_ORDERING = {
	[ RoleClassification.SUPPORT ]: 0,
	[ RoleClassification.MANAGEMENT ]: 1,
	[ RoleClassification.ARCHIVING ]: 2,
	[ RoleClassification.ADDITIONAL ]: 3
};

export const SUPPORT_ROLES_PERMISSION_LEVEL: IPermissionLevel = {
	[ RoleTypes.SUPPORT_ADMIN ]: 1,
	[ RoleTypes.SUPPORT_ADMIN_VIEW ]: 2
};

export const FISKAL_ROLES_PERMISSION_LEVEL: IPermissionLevel = {
	[ RoleTypes.SUPPORT_ADMIN ]: 1,
	[ RoleTypes.SUPPORT_ADMIN_VIEW ]: 2,
	[ RoleTypes.RESELLER_ADMIN ]: 3,
	[ RoleTypes.PARTNER_ADMIN ]: 4,
	[ RoleTypes.DISTRIBUTOR_ADMIN ]: 5,
	[ RoleTypes.VENDOR_ADMIN ]: 6,
	[ RoleTypes.ACCOUNT_ADMIN ]: 7,
	[ RoleTypes.TENANT_ADMIN ]: 8,
	[ RoleTypes.ENTITY_ADMIN ]: 9,
	[ RoleTypes.SITE_ADMIN ]: 10
};

export const ARCHIVING_ROLES_PERMISSION_LEVEL: IPermissionLevel = {
	[ RoleTypes.SUPPORT_ADMIN ]: 1,
	[ RoleTypes.SUPPORT_ADMIN_VIEW ]: 2,
	[ RoleTypes.ARCHIVE_ADMIN ]: 3,
	[ RoleTypes.ARCHIVING_USER ]: 4
};

export const ADDITIONAL_ROLES_PERMISSION_LEVEL: IPermissionLevel = {
	[ RoleTypes.SUPPORT_ADMIN ]: 1,
	[ RoleTypes.SUPPORT_ADMIN_VIEW ]: 2,
	[ RoleTypes.CUSTOMER_ADMIN ]: 3,
	[ RoleTypes.TAXPAYER ]: 3
};
